<div class="container__menuItem">
    <div class="container__menuItem__iconContainer" [ngClass]="(item.order === (navbarSelected) || item.order === (navbarSecondarySelected))?'activated':'desactivated'">
        <img [src]="'./../../../../assets/icons/'+item.iconImg" alt="" srcset="">
    </div>
    <span>{{item.label}}</span>
</div>